import tribunalAPI from "api/tribunalAPi";
import {
  ResponseDetalleReporte,
  ResponseHistorialReporte,
  ResponseMotivos,
  ResponseObtenerReportes,
  ResponseReporte,
  SolicitudAgregarReporte,
  SolicitudObtenerReportes,
} from "interfaces/reportes/reportesInterface";

const getMotivosService = async () => {
  let url = "/reporte-tribunal/obtener/motivos";
  return await tribunalAPI.get<ResponseMotivos>(url);
};

const postReporteTribunalService = async (body: SolicitudAgregarReporte) => {
  let url = "/reporte-tribunal/guardar-reporte";
  return await tribunalAPI.post<ResponseReporte>(url, body);
};

const getReporteTribunalService = async (body: SolicitudObtenerReportes) => {
  let url = "/reporte-tribunal/obtener/seguimiento";
  return await tribunalAPI.get<ResponseObtenerReportes>(url, {
    params: {
      numeroReporte: body?.numeroReporte,
      anioReporte: body?.anioReporte,
      fechaInicial: body?.fechaInicial,
      fechaFinal: body?.fechaFinal,
      page: body?.page,
      perPage: body?.perPage,
    },
  });
};

const getDetallesReporte = async (idReporte: number) => {
  let url = `/reporte-tribunal/obtener/resumen-reporte?idSeguimientoReporte=${idReporte}`;
  return await tribunalAPI.get<ResponseDetalleReporte>(url);
};

const getHistorialReporte = async (idReporte: number) => {
  let url = `/reporte-tribunal/obtener/historial-reporte?idSeguimientoReporte=${idReporte}`;
  return await tribunalAPI.get<ResponseHistorialReporte>(url);
};

export {
  getMotivosService,
  getDetallesReporte,
  getHistorialReporte,
  getReporteTribunalService,
  postReporteTribunalService,
};
